import Layout from '@/components/feature/Layout';
import Hero from './components/Hero';
import CategoryShowcase from './components/CategoryShowcase';
import NewSeasonSection from './components/NewSeasonSection';
import AnimeLibrarySection from './components/AnimeLibrarySection';
import RankingSection from './components/RankingSection';
import ArticleSection from './components/ArticleSection';

const faqSchema = [
  {
    '@type': 'Question',
    name: '动漫网收录哪些类型的动漫与漫画？',
    acceptedAnswer: {
      '@type': 'Answer',
      text: '动漫网收录日漫、国漫、新番动画以及少年漫、少女漫、青年漫等各类漫画，并支持按热血、奇幻、恋爱、科幻、治愈等标签快速筛选。',
    },
  },
  {
    '@type': 'Question',
    name: '如何快速找到想看的动画？',
    acceptedAnswer: {
      '@type': 'Answer',
      text: '你可以通过顶部的搜索框输入作品名称，或进入动画库、漫画分类页面，点击分类标签进行快速筛选，一站直达目标作品。',
    },
  },
  {
    '@type': 'Question',
    name: '动漫网会更新每季新番吗？',
    acceptedAnswer: {
      '@type': 'Answer',
      text: '会的。动漫网每季都会整理新番速递，抢先发布值得关注的最新动画，帮助用户第一时间掌握追番动态。',
    },
  },
];

export default function Home() {
  return (
    <Layout withPadding={false}>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '动漫网 - 全部动漫列表 动画库 漫画分类大全',
            url: 'https://mangaplexx.github.io/',
            isPartOf: { '@type': 'WebSite', name: '动漫网', url: 'https://mangaplexx.github.io/' },
            inLanguage: 'zh-CN',
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqSchema,
          }),
        }}
      />
      <Hero />
      <CategoryShowcase />
      <NewSeasonSection />
      <AnimeLibrarySection />
      <RankingSection />
      <ArticleSection />
    </Layout>
  );
}